import { Controller } from "stimulus";
import Swiper, { Autoplay, Navigation, Lazy, Pagination, Thumbs } from "swiper";
import { doNotLazyLoad } from "../helpers";

Swiper.use(Navigation);
Swiper.use(Autoplay);
Swiper.use(Lazy);
Swiper.use(Pagination);
Swiper.use(Thumbs);

export default class extends Controller {
  static targets = ["carousel", "prev", "next", "pagination", "thumbs"];
  swiper;
  thumbsSwiper;

  get el() {
    return this.data.has("selector")
      ? this.element.querySelector(this.data.get("selector"))
      : this.element;
  }

  get config() {
    let config = JSON.parse(this.data.get("config"));

    let defaults = {
      on: {
        init: (swiper) => this.handleInitialized(swiper),
      },
      navigation: {
        prevEl: this.hasPrevTarget ? this.prevTarget : null,
        nextEl: this.hasNextTarget ? this.nextTarget : null,
      },
      pagination: {
        el: this.hasPaginationTarget ? this.paginationTarget : null,
        type: "bullets",
      },
      thumbs: {
        swiper: this.thumbsSwiper,
        multipleActiveThumbs: false,
      },
    };

    if (!config) {
      return defaults;
    }

    return Object.assign(defaults, config);
  }

  /**
   * Dont load the carousel until all the assets (like fonts) are loaded.
   * Late font loads can shift element positions and break swiper.
   */
  connect() {
    this.element.querySelectorAll("img").forEach(doNotLazyLoad);
    this.init();
  }

  init() {
    if (this.hasThumbsTarget) {
      this.thumbsSwiper = new Swiper(this.thumbsTarget, {
        spaceBetween: 10,
        slidesPerView: 3,
        watchSlidesProgress: true,
        centeredSlides: false,
        autoScrollOffset: 1,
        freeMode: true,
        simulateTouch: true,
        shortSwipes: false,
      });
    }
    this.swiper = new Swiper(this.carouselTarget, this.config);
  }

  handleInitialized = (swiper) => {
    this.element.classList.remove("invisible");
    swiper.update();
    setTimeout(() => swiper.update(), 20);
  };

  disconnect() {
    this.swiper.destroy();
  }
}
